import * as Sentry from "@sentry/browser";

export default function initializeSentry() {
  console.log('Sentry init')

  Sentry.init({
    dsn: "https://65edd3397217a961b5018cac9bc8c4e0@sentry.baladapp.com.br/35",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
      Sentry.replayIntegration(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production

    debug: false,
    environment: process.env.NODE_ENV,
    tracesSampleRate: 0.05,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 0.05,

    ignoreErrors: [
      "Network Error",
      "Can't find variable: _AutofillCallbackHandler",
      "Loading chunk 996 failed", // erro integração do chat com zendesk
      "RA-Reputation: bad response from server https://api.reclameaqui.com.br/embed-reputation/", // erro integração reclame aqui
      "Java exception was raised during method invocation",
      "Failed to read the 'localStorage' property from 'Window': Access is denied for this document.",
      "Java object is gone",
      "The operation is insecure",
      "window.webkit.messageHandlers",
      "Error invoking postMessage:",
      "[NavigationTypeDetection]",
      "Error invoking enableDidUserTypeOnKeyboardLogging:",
      "Cannot access 'Ws' before initialization",
      "Cannot access 'js' before initialization",
      
      // novos
      "Extension context invalidated.",
      "Loading chunk 996 failed.",
      "Load failed",
      "Failed to fetch",
      "undefined is not an object (evaluating 'window.webkit.messageHandlers[e].postMessage')",
      "There is no timeout scheduled with the given id",
      "Cannot read properties of undefined (reading 'length')",
      "Cannot read properties of null (reading 'window')",
      "undefined is not an object (evaluating 'v.length')",
      "undefined is not an object (evaluating 'window.webkit.messageHandlers')",
      "Cannot read properties of null (reading 'body')",
      "The string did not match the expected pattern.",
      "Error invoking enableDidUserTypeOnKeyboardLogging: Java object is gone",
      "Cannot read properties of null (reading 'focus')",
      "undefined is not an object (evaluating 'window.__firefox__.reader')",
      "Can't find variable: __firefox__",

      
      // cloudflare errors
      "t.entries.at is not a function",
      "this.i.at is not a function",

      // zendesk errors
      "undefined is not an object (evaluating 'new i.InboundFilters')",
      "Can't find variable: zE",
      "zE is not defined",
      "null is not an object (evaluating 'parent.window')",
      "can't access property \"InboundFilters\", i is undefined",


      // reclame aqui errors
      "Cannot read properties of null (reading 'appendChild')",

    ]
  });

  if (typeof CURRENT_USER !== 'undefined') {
    console.log('Sentry setUser:', CURRENT_USER)
    Sentry.withScope((scope) => {
      scope.setUser(CURRENT_USER);
    });
  }
}